import omit from '../../functions/omit';
import pick from '../../functions/pick';

export type TGroupedEntries<T> = [string, T[]][];
export type {};

declare global {
  interface ObjectConstructor {
    omit: <T extends object, K extends keyof T>(target: T, ...keys: Array<K>) => Omit<T, K>;
    pick: <T extends object, K extends keyof T>(this: T, ...keys: Array<K>) => Pick<T, K>;
    groupByEntries: <K extends PropertyKey, V>(
      items: Iterable<V>,
      keySelector: (item: V, index: number) => K
    ) => TGroupedEntries<V>;
  }

  interface Object {
    bzOmit: <T extends object, K extends keyof T>(this: T, ...keys: Array<K>) => Omit<T, K>;
    bzPick: <T extends object, K extends keyof T>(this: T, ...keys: Array<K>) => Pick<T, K>;
  }
}

if (!Object.omit) {
  Object.defineProperty(Object, 'omit', {
    writable: false,
    enumerable: false,
    value: function <T extends object, K extends keyof T>(target: T, ...keys: K[]): Omit<T, K> {
      return omit(target, ...keys);
    }
  });
}

if (!Object.pick) {
  Object.defineProperty(Object, 'pick', {
    writable: false,
    enumerable: false,
    value: function <T extends object, K extends keyof T>(target: T, ...keys: K[]): Pick<T, K> {
      return pick(target, ...keys);
    }
  });
}

if (!Object.groupByEntries) {
  Object.defineProperty(Object, 'groupByEntries', {
    writable: false,
    enumerable: false,
    value: function <K extends PropertyKey, V>(
      items: Iterable<V>,
      keySelector: (item: V, index: number) => K
    ): TGroupedEntries<V> {
      const grouped = Object.groupBy(items, keySelector) as Record<K, V[]>;
      return Object.entries<V[]>(grouped);
    }
  });
}

if (!Object.prototype.bzOmit) {
  Object.defineProperty(Object.prototype, 'bzOmit', {
    writable: false,
    enumerable: false,
    value: function <T extends object, K extends keyof T>(this: T, ...keys: Array<K>): Omit<T, K> {
      return omit(this, ...keys);
    }
  });
}

if (!Object.prototype.bzPick) {
  Object.defineProperty(Object.prototype, 'bzPick', {
    writable: false,
    enumerable: false,
    value: function <T extends object, K extends keyof T>(this: T, ...keys: K[]): Pick<T, K> {
      return pick(this, ...keys);
    }
  });
}
